export const getPerson = ({ account }) => account.person;

export const getSendMailInfo = ({ account }) => account.info;
